<modal
  #modalSnapshots
  (onClose)="close()"
  [closeButtonText]="_appService.CoreCommonLiterals?.ButtonClose"
  [(errorMessage)]="errorBackend"
  modalClass="modal-lg"
  [submitButtonDisabled]="!selectedSnapshots.length"
  [otherButtonDisabled]="!selectedSnapshots.length"
  [submitButtonText]="showManageSnapshots ? _appService.CoreCommonLiterals?.Download : null " (onSubmit)="showManageSnapshots ? downloadSnapshots() : null"
  [otherButtonText]="showManageSnapshots ? _appService?.CoreCommonLiterals?.Delete : null "
  (onAction)="showManageSnapshots ? confirmOnRemove() : null"
>
  <modal-header>{{showManageSnapshots ? _appService.CoreCommonLiterals?.ManageSnapshots : 'Snapshots'}}</modal-header>
  <modal-content *ngIf="!showManageSnapshots">
    <div class="image embed-responsive embed-responsive-4by3" [ngStyle]="{'background-image': 'url('+imageUrl+')'}" >
      <div id="controls-container" *ngIf="imageUrl">
        <div class="buttons" *ngIf="cameraSnapshots.PreviousID || cameraSnapshots.NextID">
          <div id="controls inline-block">
            <a
              id="btn_prev"
              href="#"
              (click)="goPrevious($event, cameraSnapshots.PreviousID);"
              [ngClass]="{
                'invisible' : cameraSnapshots.PreviousID < 1 || (minSnapshotID > 0 && cameraSnapshots.CameraSnapshotID === minSnapshotID)
              }"
            >
              <i class="fas fa-arrow-left mr-1"></i>
            </a>
            <a
              id="btn_next"
              href="#"
              (click)="goNext($event, cameraSnapshots.NextID);"
              [ngClass]="{
                'invisible' : cameraSnapshots.NextID < 1 || (maxSnapshotID && cameraSnapshots.CameraSnapshotID === maxSnapshotID)
              }"
            >
              <i class="fas fa-arrow-right ml-1"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div id="snapshot-timestamp" class="my-2" *ngIf="cameraSnapshots.LocalDateTimeString">
      <span>{{cameraSnapshots.LocalDateTimeString}}</span>
    </div>
    <div class="center" *ngIf="!imageUrl">
      <i *ngIf="status === 0" class="fas fa-circle-notch fa-spin fa-2x"></i>
      <span *ngIf="!imageUrl">{{_appService.CoreCommonLiterals.NoSnapshots}}</span>
    </div>
  </modal-content>
  <modal-content *ngIf="showManageSnapshots">
    <div class="alert alert-info col-sm-12 alert-dismissible fade show" *ngIf="cameraSnapshotsList.length">
      <i class="fas fa-info-circle mr-1 fa-lg icon-info"></i>
      {{_appService.CoreCommonLiterals?.ManageSnapshotsMessage}}
    </div>
    <div class="row p-3" [ngStyle]="{'min-height': !cameraSnapshotsList.length ? '400px' : '', 'opacity': (loadSnapshots != 0) ? '1' : '0'}" >
      <div class="col-12 px-2">
        <div class="custom-control custom-checkbox mr-3 d-inline-block">
          <input type="checkbox" class="custom-control-input" name="checkAll" id="checkAll" [(ngModel)]="_selectAllSnapshots" (change)="checkAll()">
          <label class="custom-control-label" for="checkAll">{{_appService.CoreCommonLiterals.MultiSelect_All_Male}}</label>
        </div>
        <div class="custom-control custom-checkbox d-inline-block">
          <input type="checkbox" class="custom-control-input" name="unCheckAll" id="unCheckAll" [(ngModel)]="_unCheckAllSnapshots" (change)="unCheckAll()">
          <label class="custom-control-label" for="unCheckAll">{{_appService.CoreCommonLiterals?.None_Male}}</label>
        </div>
        <hr>
      </div>
      <label class="card col-md-6 col-lg-3 px-2" *ngFor="let item of cameraSnapshotsList; let i = index;" tabindex="0">
        <input class="card__input" type="checkbox" [(ngModel)]="item.Checked" [id]="'snapshot-image-'+i" [name]="'snapshot-image-'+i" (change)="selectSnapshot(item)">
        <div class="card__body">
          <span class="uncheck" [ngClass]="{'d-none': item.Checked}" id="image"></span>
          <div class="card__body-cover"><img class="card__body-cover-image" [src]="item.FileAsset.Url">
            <span class="card__body-cover-checkbox">
              <svg class="card__body-cover-checkbox--svg" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg">
                <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
              </svg>
            </span>
          </div>
          <header class="card__body-header">
            <p class="card__body-header-title mb-0 text-truncate" style="min-height: 24px;" [tooltip]="item.WidgetDescription">{{item.WidgetDescription}}</p>
            <p class="card__body-header-subtitle text-truncate mb-1" style="min-height: 20px;" [tooltip]="item.EndpointDescription">{{item.EndpointDescription}}</p>
            <div id="snapshot-timestamp" class="bottom-center">
              <span>{{item.DateString}}</span>
            </div>
          </header>
        </div>
      </label>
    </div>
    <div class="center" *ngIf="!cameraSnapshotsList.length || loadSnapshots === 0">
      <i *ngIf="loadSnapshots === 0" class="fas fa-circle-notch fa-spin fa-2x"></i>
      <span *ngIf="loadSnapshots === 1 && !cameraSnapshotsList.length">{{_appService.CoreCommonLiterals.NoSnapshots}}</span>
    </div>
  </modal-content>
</modal>

<modal-confirm #confirmRemove [title]="_appService.CoreCommonLiterals.Delete + ' - ' + _appService.CoreCommonLiterals.Images"
  [content]="_appService.CoreCommonLiterals.SureYouWantToContinue"
  [submitButtonText]="_appService.CoreCommonLiterals.ButtonConfirm"
  (submit)="deleteSnapshots()"
  [(errorMessage)]="errorMessage"
  [closeButtonText]="_appService.CoreCommonLiterals.ButtonCancel">
</modal-confirm>
